<template>
    <FloatComponent title="Video" idx="video-player" x="100px" y="100px" :show="true">
        <TSAControl /> 
        <v-sheet :height="auto" :width="auto" border rounded>
            <v-container fluid>
                <v-row>
                    <TSAMission class="centerMission"></TSAMission>
                </v-row>
                <v-row class="" style="position: relative;">
                    <div
                        :style="{
                            width: videoWidth + 'px',
                            height: videoHeight + 'px',
                            position: 'relative'
                        }"
                    >
                        <iframe
                            ref="videoIframe"
                            :width="videoWidth"
                            :height="videoHeight"
                            :src="videoUrl"
                            allowfullscreen
                        ></iframe>
                        <canvas
                            ref="videoCanvas"
                            :width="videoWidth"
                            :height="videoHeight"
                            style="position:absolute; top:0; left:0; pointer-events:auto; z-index: 2;"
                            @click="featureActive ? handleCanvasClick($event) : null"
                        ></canvas>
                    </div>
                </v-row>
                    <TSAVideoPanel></TSAVideoPanel>
             
                
            </v-container>
        </v-sheet>
    </FloatComponent>
</template>

<script>
import TSAMission from "@/views/Workspace/components/tsa/TSAMission.vue";
import TSAControl from './TSAControl.vue';
import FloatComponent from "@/components/FloatComponent.vue";
import TSAVideoPanel from "./TSAVideoPanel.vue";
import { getLiveCapacityService } from "@/services/videoService.js";
import useStore from "@/store";
import useUiStore from "@/store/ui";
import { storeToRefs } from "pinia";

import { cameraIamService } from "@/services/payloadService.js";
import { getCameraIndex } from "@/application/usecase/getCameraData.js";



export default {
    name: "TSAVideo",
    components: {
        FloatComponent,
        TSAVideoPanel,
        TSAMission,
        TSAControl
    },
    setup() {
        const { videoUrl, lentSelection, device_sn, cameraSelected } = storeToRefs(useStore());
        const { videoSizeFactor, featureActive } = storeToRefs(useUiStore());

        return {
            videoUrl,
            videoSizeFactor,
            lentSelection,
            device_sn,
            cameraSelected,
            featureActive,
        };
    },
    data: () => ({
        lastClickCoord: null
    }),
    computed: {
        videoWidth() {
            return this.videoSizeFactor * 72;
        },
        videoHeight() {
            return this.videoSizeFactor * 48;
        }
    },
    methods: {
        async getVideo() {
            const video = await getLiveCapacityService();
            console.log(video);
        },
        drawTarget() {
            if (!this.featureActive) return;
            const canvas = this.$refs.videoCanvas;
            if (!canvas) return;
            const ctx = canvas.getContext("2d");
            ctx.clearRect(0, 0, canvas.width, canvas.height);

            // Centro del canvas
            const cx = canvas.width / 2;
            const cy = canvas.height / 2;

            // Dibuja el target (círculo + cruz)
            ctx.save();
            ctx.strokeStyle = "#FF0000";
            ctx.lineWidth = 2;
            ctx.beginPath();
            ctx.arc(cx, cy, 18, 0, 2 * Math.PI);
            ctx.stroke();

            ctx.beginPath();
            ctx.moveTo(cx - 25, cy);
            ctx.lineTo(cx + 25, cy);
            ctx.moveTo(cx, cy - 25);
            ctx.lineTo(cx, cy + 25);
            ctx.stroke();
            ctx.restore();
        },
        handleCanvasClick(event) {
            // Solo si la característica esta activa
            if (!this.featureActive) return;

            const canvas = this.$refs.videoCanvas;
            const rect = canvas.getBoundingClientRect();

            let x = event.clientX - rect.left;
            let y = event.clientY - rect.top;

            
            // Coordenadas normalizadas a [-1,1], centro es (0,0)
            let nx = ((x / canvas.width));
            let ny = ((y / canvas.height));


            this.lastClickCoord = { x: nx, y: ny };
            // add move camera
            this.moveCamera(nx , ny )
        },
        async moveCamera(x, y) {
            const sn = localStorage.getItem("device_sn")
            const payloadIndex = getCameraIndex();
            const lentType = this.lentSelection
            console.warn(sn, payloadIndex, lentType)
            const result = await cameraIamService(sn, payloadIndex, lentType, false, x, y);
            console.warn(result)
        }
    },
    watch: {
        featureActive(val) {
            this.drawTarget();
            if (!val) {
                const canvas = this.$refs.videoCanvas;
                if (canvas) {
                    const ctx = canvas.getContext("2d");
                    ctx.clearRect(0, 0, canvas.width, canvas.height);
                }
            }
        },
        videoWidth() {
            this.$nextTick(() => this.drawTarget());
        },
        videoHeight() {
            this.$nextTick(() => this.drawTarget());
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.drawTarget();
        });
    },
    updated() {
        this.$nextTick(() => this.drawTarget());
    }
};
</script>

<style scoped>
.centerMission {
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>